export const invertSorting = (sorting: string) => {
  if (sorting.startsWith('-')) return sorting.slice(1);
  return '-' + sorting;
};
